import userPhoto1 from '../assets/1.jpg';
import userPhoto2 from '../assets/2.jpg';
import userPhoto3 from '../assets/3.jpg';
import userPhoto4 from '../assets/5.jpg';

export const notifications = [
    {name: 'Humayon', text: 'Are you there?', time: '5 mins', photo: userPhoto1},
    {name: 'Sohaib', text: 'Course info is updated. Please check it.', time: '5 mins', photo: userPhoto2},
    {name: 'Sophia', text: 'Here are your requested notes.', time: '5 mins', photo: userPhoto3},
    {name: 'Humayon', text: 'Make beautiful transitions', time: '5 mins', photo: userPhoto4},
];


// WEBPACK FOOTER //
// ./src/data/notifications.js